module.exports = __webpack_public_path__ + "img/Day1_final_lazy.c52ee742.jpg";